var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list",
    {
      style: { padding: "0" },
      attrs: { "two-line": _vm.compact, "three-line": !_vm.compact },
    },
    [
      _vm._l(_vm.lavorazioni, function (lav, i) {
        return [
          i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
          _c("ItemListLavorazione", {
            key: i,
            attrs: {
              "data-test": "lavorazione-in-lista-" + i,
              lavorazione: lav,
              compact: _vm.compact,
              workflow: _vm.workflow,
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }